/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/TableTimeline
 * @desc Table or Timeline based on ui persistent experiment_workflow_view
 */

import { ExperimentWorkflowTable } from 'labstep-web/components/ExperimentWorkflow/Table';
import { ExperimentWorkflowTimelineContainerWithAccess as ExperimentWorkflowTimeline } from 'labstep-web/components/ExperimentWorkflow/Timeline';
import { withUiPersistent } from 'labstep-web/containers/UiPersistent';
import { ParamsContext } from 'labstep-web/contexts/params';
import { ParamsHOC } from 'labstep-web/hoc/Params';
import type React from 'react';
import type {
  ExperimentWorkflowTableTimelineContainerProps,
  ExperimentWorkflowTableTimelineProps,
} from './types';

export const ExperimentWorkflowTableTimeline: React.FC<
  ExperimentWorkflowTableTimelineProps
> = ({
  actions,
  isTemplate,
  showCollaborators,
  experimentWorkflows,
  uiPersistent,
  setUiExperimentWorkflowView,
  showMoreAction,
  clearAll,
  ...props
}) => {
  if (
    uiPersistent.experiment_workflow_view === 'timeline' &&
    !isTemplate
  ) {
    return (
      <ExperimentWorkflowTimeline
        actions={actions}
        experimentWorkflows={experimentWorkflows}
        isTemplate={isTemplate}
        showMoreAction={showMoreAction}
        {...props}
      />
    );
  }
  return (
    <ExperimentWorkflowTable
      showCollaborators={showCollaborators}
      experimentWorkflows={experimentWorkflows}
      actions={actions}
      isTemplate={isTemplate}
      {...props}
    />
  );
};

export const ExperimentWorkflowTableTimelineContainer: React.FC<
  ExperimentWorkflowTableTimelineContainerProps
> = (props) => (
  <ParamsHOC historyAction="replace">
    <ParamsContext.Consumer>
      {({ clearAll }) => (
        <ExperimentWorkflowTableTimeline
          clearAll={clearAll}
          {...props}
        />
      )}
    </ParamsContext.Consumer>
  </ParamsHOC>
);

export default withUiPersistent(
  ExperimentWorkflowTableTimelineContainer,
);
